import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const useGsapAnimations = (refs) => {
  useEffect(() => {
    if (!refs) return;

    Object.entries(refs).forEach(([key, ref]) => {
      if (ref?.current) {
        let animationProps = {};

        // Existing animations (unchanged)
        if (key.includes("services")) {
          animationProps = { opacity: 0, x: -50 };
        } else if (key.includes("details")) {
          animationProps = { opacity: 0, x: 50 };
        } else if (key.includes("Industry") || key.includes("section")) {
          animationProps = { opacity: 0, y: 50 };
        } else {
          animationProps = { opacity: 0, y: 50 };
        }

        // New Animations (added without affecting existing ones)
        if (key.includes("scale")) {
          animationProps.scale = 0.8;
        }
        if (key.includes("rotate")) {
          animationProps.rotation = -10;
        }
        if (key.includes("fade")) {
          animationProps.opacity = 0;
        }
        if (key.includes("slide")) {
          animationProps.x = 100;
        }

        // Input field animation
        if (key.includes("input")) {
          animationProps = { opacity: 0, y: 20, scale: 0.95 };
        }

        // Check if ref contains multiple children (like cards)
        if (Array.isArray(ref.current) || ref.current.length > 1) {
          gsap.fromTo(
            ref.current,
            { opacity: 0, y: 80, scale: animationProps.scale || 1 },
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.6, // Slightly increased for better effect
              stagger: 0.15, // Faster stagger effect
              ease: "power3.out",
              scrollTrigger: {
                trigger: ref.current,
                start: "top 90%", // Trigger animation earlier
                toggleActions: "play none none none",
              },
            }
          );
        } else {
          gsap.fromTo(
            ref.current,
            animationProps,
            {
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotation: 0,
              duration: 1,
              ease: "power3.out",
              scrollTrigger: {
                trigger: ref.current,
                start: "top 85%",
                toggleActions: "play none none none",
              },
            }
          );
        }
      }
    });
  }, [refs]);
};

export default useGsapAnimations;
